module.exports = __webpack_public_path__ + "img/login-v2.1c34939a.webp";